module.exports = __webpack_public_path__ + "img/1518862496.d44f2d08.jpg";